export enum ControlType {
  Textbox = 'textbox',
  LongText = 'longtext',
  Textarea = 'textarea',
  JSON = 'json',
  PlainJSON = 'plainjson',
  Number= 'number',
  Dropdown = 'dropdown',
  Boolean = 'boolean',
  Image = 'image',
  Editor = 'editor',
  None = '',
}
